import { baseApi } from "../api";
import { HealthTargetsResponse, SaveHealthTargetsPayload } from "./types";

export const healthTargetsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHealthTargets: builder.query<HealthTargetsResponse, void>({
      query: () => ({ url: "/health-targets" }),
      providesTags: ["HealthTargets"],
    }),

    saveHealthTargets: builder.mutation<
      HealthTargetsResponse,
      SaveHealthTargetsPayload
    >({
      query: (payload) => ({
        url: "/health-targets",
        method: "put",
        data: payload,
      }),
      invalidatesTags: ["HealthTargets"],
    }),
  }),
});

export const { useGetHealthTargetsQuery, useSaveHealthTargetsMutation } =
  healthTargetsApi;
